import type { Ref } from "react"

import { Button, Card, SofiaMark, Textarea } from "@coval/ui"
import { ArrowUp, ArrowUpRight } from "lucide-react"

import { reportClass } from "./ReportStyles"

const SUGGESTIONS = [
  "Focus on the largest observed changes and next checks.",
  "Make this shorter for a leadership audience.",
  "Add a trend chart for the most active agent.",
  "Call out the biggest week-over-week change and what to inspect first.",
]
export function ReportSteering({
  busy,
  steering,
  setSteering,
  revise,
  activeCount = 0,
  queuedCount = 0,
  submitDisabled = false,
  textareaRef,
}: {
  busy: string
  steering: string
  setSteering: (value: string) => void
  revise: () => void
  activeCount?: number
  queuedCount?: number
  submitDisabled?: boolean
  textareaRef?: Ref<HTMLTextAreaElement>
}) {
  return (
    <Card className={reportClass("steering-panel")}>
      <div className={reportClass("steering-heading")}>
        <SofiaMark size={28} animated={Boolean(busy) || activeCount > 0} />
        <div>
          <h2>Make it your notebook.</h2>
          <p>
            Change the story, explore a question, or reshape a visualization.
          </p>
        </div>
      </div>
      <Textarea
        ref={textareaRef}
        aria-label="Ask Sofia to revise"
        rows={3}
        placeholder="Ask for any change — add examples, refine a section, or restyle the notebook…"
        maxLength={4000}
        disabled={Boolean(busy)}
        value={steering}
        onChange={(event) => setSteering(event.target.value)}
      />
      <p className={reportClass("revision-composer-status")} role="status">
        <span>
          Describe what you want. Sofia will use the relevant sections and
          source data.
        </span>
        {activeCount > 0 && (
          <span>
            {activeCount}{" "}
            {activeCount === 1 ? "section updating" : "sections updating"}.
          </span>
        )}
        {queuedCount > 0 && (
          <span>
            {queuedCount}{" "}
            {queuedCount === 1 ? "follow-up queued" : "follow-ups queued"} for
            busy sections.
          </span>
        )}
      </p>
      <div className={reportClass("steering-footer")}>
        <span>
          Your requests stay in this chat. Changes save automatically.
        </span>
        <Button
          disabled={Boolean(busy) || submitDisabled || !steering.trim()}
          onClick={revise}
        >
          <ArrowUp />
          Send request
        </Button>
      </div>
      <div className={reportClass("suggestions")}>
        {SUGGESTIONS.map((suggestion) => (
          <Button
            key={suggestion}
            type="button"
            variant="ghost"
            disabled={Boolean(busy)}
            onClick={() => setSteering(suggestion)}
          >
            {suggestion}
            <ArrowUpRight size={12} />
          </Button>
        ))}
      </div>
    </Card>
  )
}
